import ViewProductProfile from './ViewProductProfile';

export default ViewProductProfile;
